import {
	BROKER_ADMIN,
	LOAN_CHANNEL_CONSTANTS,
	TPO_BROKER_ADMIN_USER_TITLE,
	TPO_LOAN_OFFICER_USER_TITLE,
	TPO_SECONDARY_USER_TITLE,
} from "./common-constants";

// User title groups that may request Lock Extension / Re-Lock, by loan channel.
const WHS_CB_TITLES = [
	TPO_LOAN_OFFICER_USER_TITLE,
	TPO_SECONDARY_USER_TITLE,
	TPO_BROKER_ADMIN_USER_TITLE,
];
const NDC_CORR_TITLES = [TPO_SECONDARY_USER_TITLE, TPO_BROKER_ADMIN_USER_TITLE];

/**
 * Whether the current user may request a Lock Extension or Re-Lock for the loan channel.
 * This is only the role/channel gate; lock expiry and the Optimal Blue policy
 * (allowed) checks still apply on top of it in the Lock Info card.
 *
 * LC-698: Broker Admin is an access level ("broker admin"), not a user title.
 * Broker Admin users carry the Loan Officer / Loan Processor titles, so the
 * title-only check blocked them on NDC and Correspondent loans. They are allowed
 * there by access level, consistent with their Quick Pricer access. Users with
 * only the Loan Officer or Loan Processor title stay blocked on NDC/CORR.
 * Wholesale / Commercial Broker behaviour is unchanged.
 */
export const canRequestLockActions = ({
	loanChannel,
	userTitles,
	accessLevel,
} = {}) => {
	const titles = Array.isArray(userTitles) ? userTitles : [];
	const hasTitle = (allowed) => titles.some((title) => allowed.includes(title));

	switch (loanChannel) {
		case LOAN_CHANNEL_CONSTANTS.WHS:
		case LOAN_CHANNEL_CONSTANTS.CB:
			return hasTitle(WHS_CB_TITLES);

		case LOAN_CHANNEL_CONSTANTS.NDC:
		case LOAN_CHANNEL_CONSTANTS.CORR:
			return hasTitle(NDC_CORR_TITLES) || accessLevel === BROKER_ADMIN;

		default:
			return false;
	}
};
